<app-shipment-system-simplenav></app-shipment-system-simplenav>

<div class="p-3">
    <p *ngIf="loading" class="text-muted">Indlæser ...</p>
    <div *ngIf="_shipment">
        <app-shipment-edit-form [_shipment]="_shipment" [shipmentRoutes]="shipmentRoutes"></app-shipment-edit-form>
    </div>
</div>
